// Mirrors `feedbackBodySchema` (trim, then cap); measure the trimmed body.
import { FEEDBACK_BODY_MAX_LENGTH } from '@alphadesk/config.ts';

const COUNT_WITHIN = 200;

interface Draft {
  body: string;
  remaining: number;
  over: boolean;
  counting: boolean;
  sendable: boolean;
}

export function draftOf(typed: string): Draft {
  const body = typed.trim();
  const remaining = FEEDBACK_BODY_MAX_LENGTH - body.length;
  return {
    body,
    remaining,
    over: remaining < 0,
    counting: remaining <= COUNT_WITHIN,
    sendable: body.length > 0 && remaining >= 0,
  };
}
